import { type ReactNode } from "react";
import styles from "./SegmentedControl.module.css";

export interface SegmentedControlProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: ReactNode }[];
  id?: string;
}

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  id,
}: SegmentedControlProps<T>) {
  return (
    <div className={styles.root} role="tablist" id={id}>
      <div
        className={styles.indicator}
        style={{ width: `${100 / options.length}%`, transform: `translateX(${options.findIndex((o) => o.value === value) * 100}%)` }}
      />
      {options.map((opt) => (
        <button
          key={opt.value}
          role="tab"
          aria-selected={opt.value === value}
          className={[styles.tab, opt.value === value ? styles.active : ""].join(" ")}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}